"use client";

import { useAuth } from "@/context/auth-context";
import React, { useState } from "react";
import OtpInput from "react-otp-input";

type OtpFormProps = {
	mobile: string;
	onSwitchMode: (mode: "login" | "register" | "otp") => void;
	onClose: any;
};

export function OtpForm({ mobile, onSwitchMode, onClose }: OtpFormProps) {
	const { refreshUser } = useAuth();
	const [otp, setOtp] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleVerifyOtp = async () => {
		setLoading(true);
		setError(null);

		try {
			const res = await fetch("/api/verify-register", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ otpCode: otp }),
			});

			const data = await res.json();

			if (!res.ok) {
				setError(data.message || "خطا در تایید کد");
			}
			await refreshUser();
			onClose();
		} catch (e) {
			setError("خطا در ارتباط با سرور");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="w-full flex flex-col gap-2 text-[18px] items-center">
			<p className="text-white text-center mb-4">
				رمز یکبار مصرف ارسال شده به شماره {mobile} را وارد کنید
			</p>
			<div className="flex gap-2" style={{ direction: "ltr" }}>
				<OtpInput
					value={otp}
					onChange={setOtp}
					numInputs={6}
					containerStyle="flex gap-2"
					inputStyle={{
						width: "3rem",
						height: "3rem",
						textAlign: "center",
						backgroundColor: "#4B5563",
						border: "1px solid #9CA3AF",
						borderRadius: "0.5rem",
						fontSize: "1.25rem",
						color: "#ffffff",
					}}
					renderInput={(props) => <input {...props} />}
				/>
			</div>

			{error && <p className="text-red-400 text-center mt-2">{error}</p>}

			<div className="flex w-full gap-4 text-[15px] text-white mt-4 justify-between">
				<button className="opacity-70 hover:opacity-100">
					ارسال مجدد پیام
				</button>
				<button
					className="opacity-70 hover:opacity-100"
					onClick={() => onSwitchMode("register")}
				>
					شماره اشتباه است
				</button>
			</div>

			<button
				onClick={handleVerifyOtp}
				disabled={loading}
				className="text-black text-[20px] font-normal relative hover:opacity-70 mt-6"
				style={{
					backgroundImage: "url(/authentication-button.png)",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					width: "180px",
					height: "50px",
				}}
			>
				{loading ? "در حال بررسی..." : "ورود"}
			</button>
		</div>
	);
}
